import React from 'react';
import Header from './Header';
import SideNav from './SideNav';
import Footer from './Footer';
//import Home from "./Home"
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
const Dashboard = () => {
  useEffect(() => {
    document.title = "Host - Technical Paper Platform";
  }, []);

  return (
    <div className="wrapper">
      <Header />
      <SideNav />

      <div className="content-wrapper" style={{ minHeight: '100vh' }}>
        <section className="content pt-3 px-3">
          <div className="container-fluid">
            <Outlet />
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Dashboard;